import { render, staticRenderFns } from "./HowGuestioWorks.vue?vue&type=template&id=33abc438"
import script from "./HowGuestioWorks.vue?vue&type=script&lang=js"
export * from "./HowGuestioWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports